import { render, staticRenderFns } from "./SmCardConsultationSummary.vue?vue&type=template&id=1bfb77bc&"
import script from "./SmCardConsultationSummary.vue?vue&type=script&lang=ts&"
export * from "./SmCardConsultationSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VSpacer})
